var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ag-grid-vue',{ref:"table",staticClass:"ag-theme-alpine",staticStyle:{"height":"800px"},attrs:{"pagination":true,"paginationPageSize":300,"rowData":_vm.rowData,"columnDefs":_vm.columnDefs,"localeText":_vm.localText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }